import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/loginComponent/login.component';
import { MenuItemComponent } from './components/menu_itemComponent/menu_itemcomponent';
import { RegisterComponent } from './components/registerComponent/register.component';
import { MapComponent } from './components/mapComponent/map.component';
import { FleetStatusModalComponent } from './components/mapComponent/components/fleet-status-modal/fleet-status-modal.component';
import { SaveCarModalComponent } from './components/mapComponent/components/save-car-modal/save-car-modal.component';
import { ReportPeriodModalComponent } from './components/mapComponent/components/report-period-modal/report-period-modal.component';
import { AreaMoveModalComponent } from './components/mapComponent/components/area-move-modal/area-move-modal.component';
import { GeoFenceAnalysisModalComponent } from './components/mapComponent/components/geo-fence-analysis-modal/geo-fence-analysis-modal.component';
import { GeoFenceSaveModalComponent } from './components/mapComponent/components/geo-fence-save-modal/geo-fence-save-modal.component';
import { AreaReportModalComponent } from './components/mapComponent/components/area-report-modal/area-report-modal.component';
import { ExcelUploadModalComponent } from './components/mapComponent/components/excel-upload-modal/excel-upload-modal.component';
import { HelpModalComponent } from './components/mapComponent/components/help-modal/help-modal.component';
import { HolidaysModalComponent } from './components/mapComponent/components/holidays-modal/holidays-modal.component';
import { AddHolidayModalComponent } from './components/mapComponent/components/add-holiday-modal/add-holiday-modal.component';
import { TripModalComponent } from './components/mapComponent/components/trip-modal/trip-modal.component';
import { ExpiredCarsModalComponent } from './components/mapComponent/components/expired-cars-modal/expired-cars-modal.component';
import { NotificationService } from './Service/notification.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OtherService } from './Service/other.service';
import { MapService } from './Service/map.service';
import { ChangePassComponent } from './components/changePassComponent/changePass.component';
import { AboutComponent } from './components/aboutComponent/about.component';
import { ComponyComponent } from './components/companyComponent/company.component';
import { UserComponent } from './components/userComponent/user.component';
import { CarListComponent } from './components/car_listComponent/car_list.Component';
import { FilterPanelComponent } from './components/car_listComponent/components/filter-panel/filter-panel.component';
import { PushModalComponent } from './components/car_listComponent/components/push-modal/push-modal.component';
import { SmsModalComponent } from './components/car_listComponent/components/sms-modal/sms-modal.component';
import { ValidityModalComponent } from './components/car_listComponent/components/validity-modal/validity-modal.component';
import { AssignModalComponent } from './components/car_listComponent/components/assign-modal/assign-modal.component';
import { CarInfoComponent } from './components/car_infoComponent/car_info.component';
import { OperationModalComponent } from './components/car_infoComponent/components/operation-modal/operation-modal.component';
import { ReportModalComponent } from './components/car_infoComponent/components/report-modal/report-modal.component';
import { LocationComponent } from './components/locationComponent/location.component';
import { RepairsComponent } from './components/repairsComponent/repairs.component';
import { NgPersianDatepickerModule } from 'ng-persian-datepicker';
import { IncomeComponent } from './components/IncomeComponent/Income.component';
import { ServicesComponent } from './components/servicesComponent/services.component';
import { TablePaginationComponent } from './shared/table-pagination/table-pagination.component';
import { ChartComponent } from './shared/chart/chart.component';
import { TableTooltipComponent } from './shared/table-tooltip/table-tooltip.component';
import { SupportComponent } from './components/supportComponent/support.component';
import { TrackerComponent } from './components/trackerComponent/tracker.component';
import { NgxPersianModule } from 'ngx-persian';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { EntryCarComponent } from './components/entryCar.Component/entryCar.component';
import { GurdServiceService } from './Service/gurd-service.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ReportComponent } from './components/reportComponent/report.component';
import { OriginDestinationSummaryReportComponent } from './components/reportComponent/components/route-function-report/origin-destination-summary-report/origin-destination-summary-report.component';
import { ServiceDeliveryReportComponent } from './components/reportComponent/components/service-delivery-report/service-delivery-report.component';
import { ChartReportComponent } from './components/reportComponent/components/chart-report/chart-report.component';
import { GeofenceSummaryReportComponent } from './components/reportComponent/components/geofence-summary-report/geofence-summary-report.component';
import { DriverSalaryReportComponent } from './components/reportComponent/components/driver-salary-report/driver-salary-report.component';
import { SalaryEditModalComponent } from './components/reportComponent/components/driver-salary-report/components/salary-edit-modal/salary-edit-modal.component';
import { VehicleWorkReportComponent } from './components/reportComponent/components/vehicle-work-report/vehicle-work-report.component';
import { VehicleFinanceReportComponent } from './components/reportComponent/components/vehicle-finance-report/vehicle-finance-report.component';
import { DeviceEventsReportComponent } from './components/reportComponent/components/device-events-report/device-events-report.component';
import { StandardTableReportComponent } from './components/reportComponent/components/standard-table-report/standard-table-report.component';
import { GeofenceReportComponent } from './components/reportComponent/components/geofence-report/geofence-report.component';
import { BusReportComponent } from './components/reportComponent/components/bus-report/bus-report.component';
import { StopTankerReportComponent } from './components/reportComponent/components/stop-tanker-report/stop-tanker-report.component';
import { RouteFunctionReportComponent } from './components/reportComponent/components/route-function-report/route-function-report.component';
import { RouteSummaryReportComponent } from './components/reportComponent/components/route-function-report/route-summary-report/route-summary-report.component';
import { RouteAnalysisReportComponent } from './components/reportComponent/components/route-function-report/route-analysis-report/route-analysis-report.component';
import { RouteAnalysisTableComponent } from './components/reportComponent/components/route-function-report/route-analysis-report/route-analysis-table.component';
import { RouteReportModalComponent } from './components/reportComponent/components/route-function-report/route-analysis-report/components/route-report-modal/route-report-modal.component';
import { RouteSummaryByDayModalComponent } from './components/reportComponent/components/route-function-report/route-analysis-report/components/route-summary-by-day-modal/route-summary-by-day-modal.component';
import { RouteDriverSalaryModalComponent } from './components/reportComponent/components/route-function-report/route-analysis-report/components/route-driver-salary-modal/route-driver-salary-modal.component';
import { RoutePassengersModalComponent } from './components/reportComponent/components/route-function-report/route-analysis-report/components/route-passengers-modal/route-passengers-modal.component';
import { RouteIntermediateStationsModalComponent } from './components/reportComponent/components/route-function-report/route-analysis-report/components/route-intermediate-stations-modal/route-intermediate-stations-modal.component';
import { StopMapComponent } from './components/stopMap.Component/stopMap.component';
import { DeviceComponent } from './components/deviceComponent/device.component';
import { MenuCarComponent } from './components/menu_carComponent/menu_carcomponent';
import { DashbordComponent } from './components/dashbordComponent/dashbord.component';
import { DashboardVehicleInfoModalComponent } from './components/dashbordComponent/components/vehicle-info-modal/vehicle-info-modal.component';
import { DashboardChartVehiclesModalComponent } from './components/dashbordComponent/components/chart-vehicles-modal/chart-vehicles-modal.component';
import { DashboardClusterDetailsModalComponent } from './components/dashbordComponent/components/cluster-details-modal/cluster-details-modal.component';
import { DataService } from './Service/data.service';
import { SupportManagerComponent } from './components/supporManagerComponent/supportManager.component';
import { CarAreaComponent } from './components/car-areaComponent/car-area.component';
import { RouteComponent } from './components/routeComponent/RouteComponent';
import { RouteInfoModalComponent } from './components/routeComponent/components/route-info-modal/route-info-modal.component';
import { SaveUserComponent } from './components/saveUserComponent/saveUser.component';
import { RefuleComponent } from './components/refuleComponent/refuleComponent';
import { ManageEventComponent } from './components/manageEventComponent/manageEventComponent';
import { BusLineComponent } from './components/busLineComponent/busLine.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { TestComponent } from './components/testComponent/test.component';
import { ManageInputComponent } from './components/manageInputComponent/manageInputComponent';
import { MapInputComponent } from './components/mapInputComponent/mapInputComponent';
import { TrackerAllComponent } from './components/trackerAllComponent/trackerAll.component';
import { TaxiMeterComponent } from './components/taxiMeterComponent/taxiMeterComponent';
import { DashbordTaxiComponent } from './components/dashbordTaxiComponent/dashbordTaxi.component';
import { AdvertiseTaxiComponent } from './components/advertiseTaxiComponent/advertiseTaxiComponent';
import { SafeUrlPipe } from 'src/pipe/SafeUrlPipe';
import { DashbordAddsComponent } from './components/dashbordAddsComponent/dashbordAdds.component';
import { ReportAreaComponent } from './components/reportAreaComponent/reportAreaComponent';
import { ManageSosComponent } from './components/manageSosComponent/manageSosComponent';
import { NgxPrintModule } from 'ngx-print';
import { DashboardproComponent } from './components/dashboardpro/dashboardpro.component';
import { DashboardCombinedComponent } from './components/dashboard-combined/dashboard-combined.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { MenuPeyseparComponentComponent } from './components/menu-peysepar-component/menu-peysepar-component.component';
import { BaseInfoComponent } from './peysepar/base-info/base-info.component';
import { ServiceAreaComponent } from './peysepar/service-area/service-area.component';
import { OfficialTripsComponent } from './peysepar/official-trips/official-trips.component';
import { TripManagementComponent } from './peysepar/trip-management/trip-management.component';
import { TripCartableComponent } from './peysepar/trip-cartable/trip-cartable.component';
import { AbsenceStudentsComponent } from './schoolService/absence-students/absence-students.component';
import { AbsenceToSchoolComponent } from './schoolService/absence-to-school/absence-to-school.component';
import { AccumulativeDashboardComponent } from './schoolService/accumulative-dashboard/accumulative-dashboard.component';
import { BuffetComponent } from './schoolService/buffet/buffet.component';
import { ChangeAddressComponent } from './schoolService/change-address/change-address.component';
import { ConferencesComponent } from './schoolService/conferences/conferences.component';
import { DriverPerformanceComponent } from './schoolService/driver-performance/driver-performance.component';
import { DriverServiceComponent } from './schoolService/driver-service/driver-service.component';
import { FeedbackComponent } from './schoolService/feedback/feedback.component';
import { ManagerMessageComponent } from './schoolService/manager-message/manager-message.component';
import { NewStudentComponent } from './schoolService/new-student/new-student.component';
import { RealTimeDashboardComponent } from './schoolService/real-time-dashboard/real-time-dashboard.component';
import { SaveSchoolComponent } from './schoolService/save-school/save-school.component';
import { SearchDriversComponent } from './schoolService/search-drivers/search-drivers.component';
import { SearchStudentComponent } from './schoolService/search-student/search-student.component';
import { ServiceApplicant4schoolComponent } from './schoolService/service-applicant4school/service-applicant4school.component';
import { ServiceDeterminationComponent } from './schoolService/service-determination/service-determination.component';
import { SolutionComponent } from './schoolService/solution/solution.component';
import { StudentsAbsenceComponent } from './schoolService/students-absence/students-absence.component';
import { SuppoortComponent } from './schoolService/suppoort/suppoort.component';
import { UsersSchoolComponent } from './schoolService/users-school/users-school.component';
import { DriverFunctionComponent } from './peysepar/driver-function/driver-function.component';
import { TripBaseChartComponent } from './peysepar/trip-base-chart/trip-base-chart.component';
import { OfficeDashboardComponent } from './peysepar/office-dashboard/office-dashboard.component';
import { PresellBuffetComponent } from './schoolService/presell-buffet/presell-buffet.component';
import { BuffetSalesReportComponent } from './schoolService/buffet-sales-report/buffet-sales-report.component';
import { SchoolDashboardComponent } from './schoolService/school-dashboard/school-dashboard.component';
import { FinancialReportComponent } from './schoolService/financial-report/financial-report.component';
import { TankerListComponent } from './Tanker/tanker-list/tanker-list.component';
import { SupplyLocationsComponent } from './Tanker/supply-locations/supply-locations.component';
import { TankerDashboardComponent } from './Tanker/tanker-dashboard/tanker-dashboard.component';
import { ServiceFeeComponent } from './schoolService/service-fee/service-fee.component';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { RouteManagementComponent } from './components/route-management/route-management.component';
import { RouteScheduleComponent } from './components/route-schedule/route-schedule.component';
import { SafetyInspectionComponent } from './components/safety-inspection/safety-inspection.component';
import { ServicePartsComponent } from './components/service-parts/service-parts.component';
import { PeriodicVisitsComponent } from './components/periodic-visits/periodic-visits.component';
import { RouteDashboardComponent } from './components/route-dashboard/route-dashboard.component';
import { BusTicketQrcodeComponent } from './components/bus-ticket-qrcode/bus-ticket-qrcode.component';
import { InspectionSearchComponent } from './components/inspection-search/inspection-search.component';
import { PasswordSettingComponent } from './components/password-settings/password-setting/password-setting.component';
import { TempAccessLoginComponent } from './components/temp-access-login/temp-access-login.component';
import { TempAccessAdminComponent } from './components/temp-access-admin/temp-access-admin.component';
import { ViolationsComponent } from './components/violations/violations.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SearchTripsComponent } from './peysepar/search-trips/search-trips.component';
import { ServiceCostsComponent } from './components/service-costs/service-costs.component';
import { TripStatusComponent } from './components/trip-status/trip-status.component';
import { ChecksReportComponent } from './components/checks-report/checks-report.component';
import { BusyRoutesComponent } from './components/busy-routes/busy-routes.component';
import { UserChartComponent } from './components/user-chart/user-chart.component';
import { ChartAccessDetermineComponent } from './components/chart-access-determine/chart-access-determine.component';
import { NewTripUserComponent } from './components/new-trip-user/new-trip-user.component';
import { CustomFilterComponent } from './components/custom-filter/custom-filter.component';
import { TripNewsComponent } from './components/trip-news/trip-news.component';
import { NgxEditorModule } from 'ngx-editor';
import { RolesRoleAccessesComponent } from './roles-role-accesses/roles-role-accesses.component';
import { ActiveRentComponent } from './components/active-rent/active-rent.component';
import { BaseInfoRentalComponent } from './components/base-info-rental/base-info-rental.component';
import { PerformanceDateRentComponent } from './components/performance-date-rent/performance-date-rent.component';
import { CustomMapComponent } from './components/custom-map/custom-map.component';
import { AddedCarsComponent } from './added-cars/added-cars.component';
import { TripDriversComponent } from './components/trip-drivers/trip-drivers.component';
import { DetailServiceComponent } from './components/detail-service/detail-service.component';
import { ScrapCarsComponent } from './components/scrap-cars/scrap-cars.component';
import { TaxiManageComponent } from './components/taxi-manage/taxi-manage.component';
import { TaxiCalendarComponent } from './components/taxi-calendar/taxi-calendar.component';
import { TaxilonTariffComponent } from './components/taxilon-tariff/taxilon-tariff.component';
import { TaxilonSupportComponent } from './components/taxilon-support/taxilon-support.component';
import { TaxilonSearchComponent } from './components/taxilon-search/taxilon-search.component';
import { TaxilonSearchPassengerComponent } from './components/taxilon-search-passenger/taxilon-search-passenger.component';
import { TaxilonDebitCreditComponent } from './components/taxilon-debit-credit/taxilon-debit-credit.component';
import { TaxilonManageAdsComponent } from './components/taxilon-manage-ads/taxilon-manage-ads.component';
import { PaymentComponent } from './components/payment/payment.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { DriverAdsComponent } from './components/driver-ads/driver-ads.component';
import { NewsComponent } from './components/news/news.component';
import { InfiniteScrollDirective } from './components/infinite-scroll/directive/infinite-scroll.directive';
import { EducationComponent } from './components/education/education.component';
import { EmdadranSearchComponent } from './components/emdadran-search/emdadran-search.component';
import { ReportPaymentComponent } from './components/report-payment/report-payment.component';
import { TaxilonDashbordComponent } from './components/taxilon-dashbord/taxilon-dashbord.component';
import { EmdadranDashbordComponent } from './components/emdadran-dashbord/emdadran-dashbord.component';
import { AyabZahabComponent } from './components/ayab-zahab/ayab-zahab.component';
import { EmdadranBusinessComponent } from './components/emdadran-business/emdadran-business.component';
import { SmartClusteringComponent } from './schoolService/smart-clustering/smart-clustering.component';
import { AyabZahabDashboardComponent } from './components/ayab-zahab-dashboard/ayab-zahab-dashboard.component';
import { SurveillanceComponent } from './surveillance/surveillance.component';
import { FinancialReportsComponent } from './components/financial-reports/financial-reports.component';
import { ManageDriverPerformanceComponent } from './manage-driver-performance/manage-driver-performance.component';
import { SchollContractorComponent } from './scholl-contractor/scholl-contractor.component';
import { NetConsumedComponent } from './components/net-consumed/net-consumed.component';
import { SchoolStudentReportDailyComponent } from './components/school-student-report-daily/school-student-report-daily.component';
import { MonitoringDashboardComponent } from './components/monitoring-dashboard/monitoring-dashboard.component';
import { SchoolRequestAllocationComponent } from './components/school-request-allocation/school-request-allocation.component';
import { SchoolParentRequestsComponent } from './components/school-parent-requests/school-parent-requests.component';
import { SchoolSearchRequestsComponent } from './components/school-search-requests/school-search-requests.component';
import { SchoolContractsComponent } from './components/school-contracts/school-contracts.component';
import { EcuInformationComponent } from './components/ecu-information/ecu-information.component';
import { CctvVideoLocationsComponent } from './components/cctv-video-locations/cctv-video-locations.component';
import { CustomSurveillanceComponent } from './components/custom-surveillance/custom-surveillance.component';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { VideoPlayerModalDirective } from './components/video-player/components/video-player-modal.directive';
import { ShareVideoModalComponent } from './components/video-player/components/share-video-modal/share-video-modal.component';
import { VoiceRecordModalComponent } from './components/video-player/components/voice-record-modal/voice-record-modal.component';
import { CctvCamerasComponent } from './components/cctv-cameras/cctv-cameras.component';
import { CctvMonitoringComponent } from './components/cctv-monitoring/cctv-monitoring.component';
import { CctvImagePlayerComponent } from './components/cctv-image-player/cctv-image-player.component';
import { ImageTileComponent } from './components/cctv-monitoring/components/image-tile/image-tile.component';
import { ImageDialogComponent } from './components/cctv-monitoring/components/image-dialog/image-dialog.component';
import { MonitoringStatsComponent } from './components/cctv-monitoring/components/monitoring-stats/monitoring-stats.component';
import { CctvMonitoringMapComponent } from './components/cctv-monitoring-map/cctv-monitoring-map.component';
import { MonitoringMapComponent } from './components/cctv-monitoring-map/components/monitoring-map/monitoring-map.component';
import { MapImageDialogComponent } from './components/cctv-monitoring-map/components/map-image-dialog/map-image-dialog.component';
import { CctvStreamLoaderComponent } from './components/cctv-stream-loader/cctv-stream-loader.component';
import { DotoneLiveComponent } from './components/dotone-live/dotone-live.component';
import { CctvFilmReportComponent } from './components/cctv-film-report/cctv-film-report.component';
import { CctvFilmStatusComponent } from './components/cctv-film-status/cctv-film-status.component';
import { PlaylistVideoPlayerComponent } from './playlist-video-player/playlist-video-player.component';
import { ExtraClassesComponent } from './components/extra-classes/extra-classes.component';
import { EcuChartComponent } from './components/ecu-chart/ecu-chart.component';
import { EntryExitMadonikComponent } from './components/entry-exit-madonik/entry-exit-madonik.component';
import { FisheriesDashbordComponent } from './components/fisheries-dashbord/fisheries-dashbord.component';
import { VehicleRenewalComponent } from './components/vehicle-renewal/vehicle-renewal.component';
import { OfflineVehiclesComponent } from './components/offline-vehicles/offline-vehicles.component';
import { TransitRouteComponent } from './components/transit-route/transit-route.component';
import { TransitPerformanceComponent } from './components/transit-performance/transit-performance.component';
import { TransitTimeComponent } from './components/transit-performance/transit-time/transit-time.component';
import { TransitBarnamehComponent } from './components/transit-barnameh/transit-barnameh.component';
import { TransitReportStopComponent } from './components/transit-report-stop/transit-report-stop.component';
import { WithoutPlanningReportComponent } from './components/without-planning-report/without-planning-report.component';
import { ReportFlowmeterComponent } from './components/report-flowmeter/report-flowmeter.component';
import { VehicleDivisionComponent } from './components/vehicle-division/vehicle-division.component';
import { DivisionTotalComponent } from './components/division-total/division-total.component';
import { PreRegistrationComponent } from './components/pre-registration/pre-registration.component';
import { LocationTimelineComponent } from './components/location-timeline/location-timeline.component';
import { DriverInfoComponent } from './components/driver-info/driver-info.component';
import { CustomGalleryComponent } from './components/custom-gallery/custom-gallery.component';
import { NgxStarRatingModule } from 'ngx-star-rating';
import { AnalysisDischargesComponent } from './Tanker/analysis-discharges/analysis-discharges.component';
import { AnalyzeBubbleMapComponent } from './Tanker/analyze-bubble-map/analyze-bubble-map.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { GpsInstallerComponent } from './components/gps-installer/gps-installer.component';
import { TaxiManageVecationComponent } from './components/taxi-manage-vecation/taxi-manage-vecation.component';
import { TaxiMonthlyReportComponent } from './components/taxi-monthly-report/taxi-monthly-report.component';
import { TaxiStatusDashboardComponent } from './components/taxi-status-dashboard/taxi-status-dashboard.component';
import { TaxiMonthlyReportDetailsComponent } from './components/taxi-monthly-report-details/taxi-monthly-report-details.component';
import { TaxiDashboardComponent } from './components/taxi-dashboard/taxi-dashboard.component';
import { PreRegistrationDashboardComponent } from './components/pre-registration-dashboard/pre-registration-dashboard.component';
import { OnlineUsersComponent } from './components/online-users/online-users.component';
import { TankerCustomerManagementComponent } from './Tanker/tanker-customer-management/tanker-customer-management.component';
import { TankerPreRegestrationComponent } from './components/tanker-pre-regestration/tanker-pre-regestration.component';
import { RahdariPreRegistrationComponent } from './components/rahdari-pre-registration/rahdari-pre-registration.component';
import { CanDashComponent } from './components/can-dash/can-dash.component';
import { CanDashFullInfoComponent } from './components/can-dash-full-info/can-dash-full-info.component';
import { CanCounterComponent } from './components/can-dash-full-info/pages/bcm/components/can-counter.component';
import { BatteryComponent } from './components/can-dash-full-info/pages/battery/battery.component';
import { OverviewComponent } from './components/can-dash-full-info/pages/overview/overview.component';
import { BcmComponent } from './components/can-dash-full-info/pages/bcm/bcm.component';
import { VcuComponent } from './components/can-dash/pages/vcu/vcu.component';
import { FuelBasedReportComponent } from './components/fuel-based-report/fuel-based-report.component';
import { CctvDashboardComponent } from './components/cctv-dashboard/cctv-dashboard.component';
import { TelemetryCanAnalyzerComponent } from './components/telemetry-can-analyzer/telemetry-can-analyzer.component';
import { FleetdiagUsersComponent } from './components/fleetdiag-users/fleetdiag-users.component';
import { FleetdiagDashboardComponent } from './components/fleetdiag-dashboard/fleetdiag-dashboard.component';
import { FleetdiagDashboardProComponent } from './components/fleetdiag-dashboard-pro/fleetdiag-dashboard-pro.component';
import { FleetdiagLiveParametersComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-live-parameters/fleetdiag-live-parameters.component';
import { FleetdiagAllItemsComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-all-items/fleetdiag-all-items.component';
import { FleetdiagDynamicChartComponent } from './components/fleetdiag-dashboard-pro/components/fleetdiag-dynamic-chart/fleetdiag-dynamic-chart.component';
import { RpmGaugeComponent } from './components/fleetdiag-dashboard-pro/components/rpm-gauge/rpm-gauge.component';
import { ThermometerComponent } from './components/fleetdiag-dashboard-pro/components/thermometer/thermometer.component';
import { FleetdiagFullscreenChartComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-fullscreen-chart/fleetdiag-fullscreen-chart.component';
import { FleetdiagDrivingQualityComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-driving-quality/fleetdiag-driving-quality.component';
import { SpeedGaugeComponent } from './components/fleetdiag-dashboard-pro/components/speed-gauge/speed-gauge.component';
import { FleetdiagObdMonitorComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-obd-monitor/fleetdiag-obd-monitor.component';
import { FleetdiagEcuStatusComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-ecu-status/fleetdiag-ecu-status.component';
import { TankerSupplyDetailsComponent } from './Tanker/tanker-supply-details/tanker-supply-details.component';
import { TankerShowAllMapComponent } from './Tanker/tanker-show-all-map/tanker-show-all-map.component';
import { TankerIllegalWaterPercentageComponent } from './Tanker/tanker-illegal-water-percentage/tanker-illegal-water-percentage.component';
import { TankerDriversRiskRankingComponent } from './Tanker/tanker-drivers-risk-ranking/tanker-drivers-risk-ranking.component';
import { TankerIllegalWaterSourcesComponent } from './Tanker/tanker-illegal-water-sources/tanker-illegal-water-sources.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { DeviceRegistrationComponent } from './components/device-registration/device-registration.component';
import { NumericOnlyDirective } from './shared/directives/numeric-only.directive';
import { DecimalOnlyDirective } from './shared/directives/decimal-only.directive';
import { FleetdiagPollutionChartComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-indicators/pages/fleetdiag-pollution-chart/fleetdiag-pollution-chart.component';
import { FleetdiagEngineHealthComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-indicators/pages/fleetdiag-engine-health/fleetdiag-engine-health.component';
import { FleetdiagCombustionQualityComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-indicators/pages/fleetdiag-combustion-quality/fleetdiag-combustion-quality.component';
import { FleetdiagFuelEfficiencComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-indicators/pages/fleetdiag-fuel-efficienc/fleetdiag-fuel-efficienc.component';
import { FleetdiagAirIntakeComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-indicators/pages/fleetdiag-air-intake/fleetdiag-air-intake.component';
import { FleetdiagElectricalSystemHealthComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-indicators/pages/fleetdiag-electrical-system-health/fleetdiag-electrical-system-health.component';
import { FleetdiagFailureRiskComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-indicators/pages/fleetdiag-failure-risk/fleetdiag-failure-risk.component';
import { FleetdiagIndicatorsComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-indicators/fleetdiag-indicators.component';
import { FleetdiagIndicatorsOverviewComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-indicators/pages/fleetdiag-indicators-overview/fleetdiag-indicators-overview.component';
import { FleetdiagHealthReportComponent } from './components/fleetdiag-dashboard-pro/pages/fleetdiag-indicators/pages/fleetdiag-health-report/fleetdiag-health-report.component';
import { LoadWatchListComponent } from './components/iot/load-watch/load-watch-list/load-watch-list.component';
import { LoadWatchDashboardComponent } from './components/iot/load-watch/load-watch-dashboard/load-watch-dashboard.component';
import { LoadWatchOverviewComponent } from './components/iot/load-watch/load-watch-overview/load-watch-overview.component';
import { LoadWatchGeneratorHealthComponent } from './components/iot/load-watch/load-watch-generator-health/load-watch-generator-health.component';
import { LoadWatchChartComponent } from './components/iot/load-watch/load-watch-chart/load-watch-chart.component';
import { LoadWatchPerformanceComponent } from './components/iot/load-watch/load-watch-performance/load-watch-performance.component';
import { LoadWatchEnergyComponent } from './components/iot/load-watch/load-watch-energy/load-watch-energy.component';
import { LoadWatchVoltageCurrentComponent } from './components/iot/load-watch/load-watch-voltage-current/load-watch-voltage-current.component';
import { LoadWatchPerformanceAllComponent } from './components/iot/load-watch/load-watch-performance-all/load-watch-performance-all.component';
import { LoadWatchDashboardLayoutComponent } from './components/iot/load-watch/load-watch-dashboard-layout/load-watch-dashboard-layout.component';
import { LoadWatchDashboardAllComponent } from './components/iot/load-watch/load-watch-dashboard-all/load-watch-dashboard-all.component';
import { LoadWatchDashboardPerformanceComponent } from './components/iot/load-watch/load-watch-dashboard-layout/pages/load-watch-dashboard-performance/load-watch-dashboard-performance.component';
import { LoadWatchDashboardIndicatorsComponent } from './components/iot/load-watch/load-watch-dashboard-layout/pages/load-watch-dashboard-indicators/load-watch-dashboard-indicators.component';
import { LoadWatchDashboardPeriodicAnalysisComponent } from './components/iot/load-watch/load-watch-dashboard-layout/pages/load-watch-dashboard-periodic-analysis/load-watch-dashboard-periodic-analysis.component';
import { TankerExecutionReportComponent } from './Tanker/tanker-execution-report/tanker-execution-report.component';
import { TankerAreasComponent } from './Tanker/tanker-areas/tanker-areas.component';
import { TankerWaterRequestsComponent } from './Tanker/tanker-water-requests/tanker-water-requests.component';
import { AdvertisingComponent } from './components/advertising/advertising.component';
import { TelemetryDashboardComponent } from './components/telemetry-dashboard/telemetry-dashboard.component';
import { TelemetrySafetyDashboardComponent } from './components/telemetry-safety-dashboard/telemetry-safety-dashboard.component';
import { SafetyVehicleModalComponent } from './components/telemetry-safety-dashboard/components/safety-vehicle-modal/safety-vehicle-modal.component';
import { SafetyDashboardComponent } from './components/safety-dashboard/safety-dashboard.component';
import { SafetyOverviewComponent } from './components/safety-dashboard/components/safety-overview/safety-overview.component';
import { SafetySpeedComponent } from './components/safety-dashboard/components/safety-speed/safety-speed.component';
import { SafetyRiskComponent } from './components/safety-dashboard/components/safety-risk/safety-risk.component';
import { SafetyQualityComponent } from './components/safety-dashboard/components/safety-quality/safety-quality.component';
import { SafetyTableComponent } from './components/safety-dashboard/components/safety-table/safety-table.component';
import { FleetStatusComponent } from './components/fleet-status/fleet-status.component';
import { SuspiciousActivityComponent } from './components/suspicious-activity/suspicious-activity.component';
import { FraudDashboardComponent } from './components/suspicious-activity/components/fraud-dashboard/fraud-dashboard.component';
import { CasesComponent } from './components/suspicious-activity/components/cases/cases.component';
import { ReviewHistoryComponent } from './components/suspicious-activity/components/review-history/review-history.component';
import { FraudOverviewComponent } from './components/suspicious-activity/components/fraud-dashboard/components/fraud-overview/fraud-overview.component';
import { FraudCasesComponent } from './components/suspicious-activity/components/fraud-dashboard/components/fraud-cases/fraud-cases.component';
import { FraudCaseDetailsComponent } from './components/suspicious-activity/components/fraud-dashboard/components/fraud-case-details/fraud-case-details.component';
import { FraudCaseSummaryComponent } from './components/suspicious-activity/components/fraud-dashboard/components/fraud-case-details/components/fraud-case-summary/fraud-case-summary.component';
import { FraudCaseEvidenceComponent } from './components/suspicious-activity/components/fraud-dashboard/components/fraud-case-details/components/fraud-case-evidence/fraud-case-evidence.component';
import { FraudCaseRoutesComponent } from './components/suspicious-activity/components/fraud-dashboard/components/fraud-case-details/components/fraud-case-routes/fraud-case-routes.component';
import { FraudCaseReviewComponent } from './components/suspicious-activity/components/fraud-dashboard/components/fraud-case-details/components/fraud-case-review/fraud-case-review.component';
import { FraudAnalysisComponent } from './components/suspicious-activity/components/fraud-dashboard/components/fraud-analysis/fraud-analysis.component';
import { VoltageWithSpeedComponent } from './components/report-dashboard/voltage-with-speed/voltage-with-speed.component';
import { VoltageSpeedKpisComponent } from './components/report-dashboard/voltage-with-speed/components/kpis/kpis.component';
import { VoltageSpeedTimelineComponent } from './components/report-dashboard/voltage-with-speed/components/timeline/timeline.component';
import { VoltageSpeedEngineStateComponent } from './components/report-dashboard/voltage-with-speed/components/engine-state/engine-state.component';
import { VoltageSpeedScatterComponent } from './components/report-dashboard/voltage-with-speed/components/speed-voltage-scatter/speed-voltage-scatter.component';
import { VoltageSpeedProfileComponent } from './components/report-dashboard/voltage-with-speed/components/voltage-profile/voltage-profile.component';
import { VoltageSpeedChargingStabilityComponent } from './components/report-dashboard/voltage-with-speed/components/charging-stability/charging-stability.component';
import { VoltageSpeedDataQualityComponent } from './components/report-dashboard/voltage-with-speed/components/data-quality/data-quality.component';
import { VoltageSpeedCorrelationComponent } from './components/report-dashboard/voltage-with-speed/components/correlation/correlation.component';
import { VoltageSpeedSummaryKpiComponent } from './components/report-dashboard/voltage-with-speed/components/summary-kpi/summary-kpi.component';
import { VoltageSpeedAnomaliesComponent } from './components/report-dashboard/voltage-with-speed/components/voltage-anomalies/voltage-anomalies.component';
import { VoltageSpeedHistoricalBaselineComponent } from './components/report-dashboard/voltage-with-speed/components/historical-baseline/historical-baseline.component';
import { VoltageSpeedDailyInsightsComponent } from './components/report-dashboard/voltage-with-speed/components/daily-insights/daily-insights.component';
import { VoltageSpeedDailyEventsComponent } from './components/report-dashboard/voltage-with-speed/components/daily-events/daily-events.component';
import { VehicleFingerprintComponent } from './components/vehicle-fingerprint/vehicle-fingerprint.component';
import { VehicleFingerprintIdentityComponent } from './components/vehicle-fingerprint/components/identity/identity.component';
import { VehicleFingerprintQualityComponent } from './components/vehicle-fingerprint/components/quality/quality.component';
import { VehicleFingerprintKpiPanelComponent } from './components/vehicle-fingerprint/components/kpi-panel/kpi-panel.component';
import { VehicleFingerprintElectricalSignatureComponent } from './components/vehicle-fingerprint/components/electrical-signature/electrical-signature.component';
import { VehicleFingerprintSpeedProfileComponent } from './components/vehicle-fingerprint/components/speed-profile/speed-profile.component';
import { VehicleFingerprintSpeedTrendComponent } from './components/vehicle-fingerprint/components/speed-trend/speed-trend.component';
import { VehicleFingerprintDailyDistanceComponent } from './components/vehicle-fingerprint/components/daily-distance/daily-distance.component';
import { VehicleFingerprintDailyPatternComponent } from './components/vehicle-fingerprint/components/daily-pattern/daily-pattern.component';
import { VehicleFingerprintDailyActivityComponent } from './components/vehicle-fingerprint/components/daily-activity/daily-activity.component';
import { VehicleFingerprintDataCoverageComponent } from './components/vehicle-fingerprint/components/data-coverage/data-coverage.component';
import { VehicleFingerprintBehavioralFeaturesComponent } from './components/vehicle-fingerprint/components/behavioral-features/behavioral-features.component';
import { VehicleFingerprintGeographicSignatureComponent } from './components/vehicle-fingerprint/components/geographic-signature/geographic-signature.component';
import { VehicleFingerprintElectricalSummaryComponent } from './components/vehicle-fingerprint/components/electrical-summary/electrical-summary.component';
import { VehicleFingerprintAdvancedElectricalComponent } from './components/vehicle-fingerprint/components/advanced-electrical/advanced-electrical.component';
import { VehicleFingerprintElectricalTrendsComponent } from './components/vehicle-fingerprint/components/electrical-trends/electrical-trends.component';

@NgModule({
  declarations: [
    AppComponent,
    ChangePassComponent,
    MapComponent,
    FleetStatusModalComponent,
    SaveCarModalComponent,
    ReportPeriodModalComponent,
    AreaMoveModalComponent,
    GeoFenceAnalysisModalComponent,
    GeoFenceSaveModalComponent,
    AreaReportModalComponent,
    ExcelUploadModalComponent,
    HelpModalComponent,
    HolidaysModalComponent,
    AddHolidayModalComponent,
    TripModalComponent,
    ExpiredCarsModalComponent,
    LoginComponent,
    RegisterComponent,
    MenuItemComponent,
    AboutComponent,
    ComponyComponent,
    UserComponent,
    CarListComponent,
    FilterPanelComponent,
    PushModalComponent,
    SmsModalComponent,
    ValidityModalComponent,
    AssignModalComponent,
    CarInfoComponent,
    OperationModalComponent,
    ReportModalComponent,
    LocationComponent,
    RepairsComponent,
    IncomeComponent,
    ServicesComponent,
    TablePaginationComponent,
    ChartComponent,
    TableTooltipComponent,
    SupportComponent,
    SupportManagerComponent,
    TrackerComponent,
    RouteComponent,
    RouteInfoModalComponent,
    EntryCarComponent,
    ReportComponent,
    OriginDestinationSummaryReportComponent,
    ServiceDeliveryReportComponent,
    ChartReportComponent,
    GeofenceSummaryReportComponent,
    DriverSalaryReportComponent,
    SalaryEditModalComponent,
    VehicleWorkReportComponent,
    VehicleFinanceReportComponent,
    DeviceEventsReportComponent,
    StandardTableReportComponent,
    GeofenceReportComponent,
    BusReportComponent,
    StopTankerReportComponent,
    RouteFunctionReportComponent,
    RouteSummaryReportComponent,
    RouteAnalysisReportComponent,
    RouteAnalysisTableComponent,
    RouteReportModalComponent,
    RouteSummaryByDayModalComponent,
    RouteDriverSalaryModalComponent,
    RoutePassengersModalComponent,
    RouteIntermediateStationsModalComponent,
    StopMapComponent,
    DeviceComponent,
    MenuCarComponent,
    DashbordComponent,
    DashboardVehicleInfoModalComponent,
    DashboardChartVehiclesModalComponent,
    DashboardClusterDetailsModalComponent,
    CarAreaComponent,
    SaveUserComponent,
    RefuleComponent,
    ManageEventComponent,
    BusLineComponent,
    ManageInputComponent,
    BusLineComponent,
    MapInputComponent,
    TestComponent,
    TrackerAllComponent,
    TaxiMeterComponent,
    DashbordTaxiComponent,
    AdvertiseTaxiComponent,
    SafeUrlPipe,
    DashbordAddsComponent,
    ReportAreaComponent,
    ManageSosComponent,
    DashboardproComponent,
    DashboardCombinedComponent,
    MenuPeyseparComponentComponent,
    BaseInfoComponent,
    ServiceAreaComponent,
    OfficialTripsComponent,
    TripManagementComponent,
    TripCartableComponent,
    DriverPerformanceComponent,
    DriverServiceComponent,
    NewStudentComponent,
    RealTimeDashboardComponent,
    SaveSchoolComponent,
    SearchStudentComponent,
    UsersSchoolComponent,
    AccumulativeDashboardComponent,
    SearchDriversComponent,
    StudentsAbsenceComponent,
    ChangeAddressComponent,
    FeedbackComponent,
    ServiceDeterminationComponent,
    AbsenceToSchoolComponent,
    AbsenceStudentsComponent,
    ServiceApplicant4schoolComponent,
    ConferencesComponent,
    ManagerMessageComponent,
    BuffetComponent,
    SolutionComponent,
    SuppoortComponent,
    DriverFunctionComponent,
    TripBaseChartComponent,
    OfficeDashboardComponent,
    PresellBuffetComponent,
    BuffetSalesReportComponent,
    SchoolDashboardComponent,
    FinancialReportComponent,
    TankerListComponent,
    SupplyLocationsComponent,
    TankerDashboardComponent,
    ServiceFeeComponent,
    RouteManagementComponent,
    RouteScheduleComponent,
    SafetyInspectionComponent,
    ServicePartsComponent,
    PeriodicVisitsComponent,
    RouteDashboardComponent,
    BusTicketQrcodeComponent,
    InspectionSearchComponent,
    PasswordSettingComponent,
    TempAccessLoginComponent,
    TempAccessAdminComponent,
    ViolationsComponent,
    SearchTripsComponent,
    ServiceCostsComponent,
    TripStatusComponent,
    ChecksReportComponent,
    BusyRoutesComponent,
    UserChartComponent,
    ChartAccessDetermineComponent,
    NewTripUserComponent,
    CustomFilterComponent,
    TripNewsComponent,
    RolesRoleAccessesComponent,
    ActiveRentComponent,
    BaseInfoRentalComponent,
    PerformanceDateRentComponent,
    CustomMapComponent,
    AddedCarsComponent,
    TripDriversComponent,
    DetailServiceComponent,
    ScrapCarsComponent,
    TaxiManageComponent,
    TaxiCalendarComponent,
    TaxilonTariffComponent,
    TaxilonSupportComponent,
    TaxilonSearchComponent,
    TaxilonSearchPassengerComponent,
    TaxilonDebitCreditComponent,
    TaxilonManageAdsComponent,
    PaymentComponent,
    DriverAdsComponent,
    NewsComponent,
    InfiniteScrollDirective,
    EducationComponent,
    EmdadranSearchComponent,
    ReportPaymentComponent,
    TaxilonDashbordComponent,
    EmdadranDashbordComponent,
    AyabZahabComponent,
    EmdadranBusinessComponent,
    SmartClusteringComponent,
    AyabZahabDashboardComponent,
    SurveillanceComponent,
    FinancialReportsComponent,
    ManageDriverPerformanceComponent,
    SchollContractorComponent,
    NetConsumedComponent,
    SchoolStudentReportDailyComponent,
    MonitoringDashboardComponent,
    SchoolRequestAllocationComponent,
    SchoolParentRequestsComponent,
    SchoolSearchRequestsComponent,
    SchoolContractsComponent,
    EcuInformationComponent,
    CctvVideoLocationsComponent,
    CustomSurveillanceComponent,
    VideoPlayerComponent,
    VoiceRecordModalComponent,
    ShareVideoModalComponent,
    VideoPlayerModalDirective,
    CctvCamerasComponent,
    CctvMonitoringComponent,
    CctvImagePlayerComponent,
    ImageTileComponent,
    ImageDialogComponent,
    MonitoringStatsComponent,
    CctvMonitoringMapComponent,
    MapImageDialogComponent,
    MonitoringMapComponent,
    CctvStreamLoaderComponent,
    DotoneLiveComponent,
    CctvFilmReportComponent,
    CctvFilmStatusComponent,
    PlaylistVideoPlayerComponent,
    ExtraClassesComponent,
    EcuChartComponent,
    EntryExitMadonikComponent,
    FisheriesDashbordComponent,
    VehicleRenewalComponent,
    OfflineVehiclesComponent,
    TransitRouteComponent,
    TransitPerformanceComponent,
    TransitTimeComponent,
    TransitBarnamehComponent,
    TransitReportStopComponent,
    WithoutPlanningReportComponent,
    ReportFlowmeterComponent,
    VehicleDivisionComponent,
    DivisionTotalComponent,
    PreRegistrationComponent,
    LocationTimelineComponent,
    DriverInfoComponent,
    CustomGalleryComponent,
    AnalysisDischargesComponent,
    AnalyzeBubbleMapComponent,
    GpsInstallerComponent,
    TaxiManageVecationComponent,
    TaxiMonthlyReportComponent,
    TaxiStatusDashboardComponent,
    TaxiMonthlyReportDetailsComponent,
    TaxiDashboardComponent,
    PreRegistrationDashboardComponent,
    OnlineUsersComponent,
    TankerCustomerManagementComponent,
    TankerPreRegestrationComponent,
    RahdariPreRegistrationComponent,
    CanDashComponent,
    CanDashFullInfoComponent,
    CanCounterComponent,
    OverviewComponent,
    BatteryComponent,
    BcmComponent,
    VcuComponent,
    FuelBasedReportComponent,
    CctvDashboardComponent,
    TelemetryCanAnalyzerComponent,
    FleetdiagUsersComponent,
    FleetdiagDashboardComponent,
    FleetdiagDashboardProComponent,
    FleetdiagLiveParametersComponent,
    FleetdiagAllItemsComponent,
    FleetdiagDynamicChartComponent,
    RpmGaugeComponent,
    ThermometerComponent,
    FleetdiagFullscreenChartComponent,
    FleetdiagHealthReportComponent,
    FleetdiagDrivingQualityComponent,
    SpeedGaugeComponent,
    FleetdiagObdMonitorComponent,
    FleetdiagEcuStatusComponent,
    TankerSupplyDetailsComponent,
    TankerShowAllMapComponent,
    TankerIllegalWaterPercentageComponent,
    TankerDriversRiskRankingComponent,
    TankerIllegalWaterSourcesComponent,
    DeviceRegistrationComponent,
    NumericOnlyDirective,
    DecimalOnlyDirective,
    FleetdiagPollutionChartComponent,
    FleetdiagEngineHealthComponent,
    FleetdiagCombustionQualityComponent,
    FleetdiagFuelEfficiencComponent,
    FleetdiagAirIntakeComponent,
    FleetdiagElectricalSystemHealthComponent,
    FleetdiagFailureRiskComponent,
    FleetdiagIndicatorsComponent,
    FleetdiagIndicatorsOverviewComponent,
    LoadWatchListComponent,
    LoadWatchDashboardComponent,
    LoadWatchOverviewComponent,
    LoadWatchGeneratorHealthComponent,
    LoadWatchChartComponent,
    LoadWatchPerformanceComponent,
    LoadWatchEnergyComponent,
    LoadWatchVoltageCurrentComponent,
    LoadWatchPerformanceAllComponent,
    LoadWatchDashboardAllComponent,
    LoadWatchDashboardLayoutComponent,
    LoadWatchDashboardPerformanceComponent,
    LoadWatchDashboardIndicatorsComponent,
    LoadWatchDashboardPeriodicAnalysisComponent,
    TankerExecutionReportComponent,
    TankerAreasComponent,
    TankerWaterRequestsComponent,
    AdvertisingComponent,
    TelemetryDashboardComponent,
    TelemetrySafetyDashboardComponent,
    SafetyVehicleModalComponent,
    SafetyDashboardComponent,
    SafetyOverviewComponent,
    SafetySpeedComponent,
    SafetyRiskComponent,
    SafetyQualityComponent,
    SafetyTableComponent,
    FleetStatusComponent,
    SuspiciousActivityComponent,
    FraudDashboardComponent,
    CasesComponent,
    ReviewHistoryComponent,
    FraudOverviewComponent,
    FraudCasesComponent,
    FraudCaseDetailsComponent,
    FraudCaseSummaryComponent,
    FraudCaseEvidenceComponent,
    FraudCaseRoutesComponent,
    FraudCaseReviewComponent,
    FraudAnalysisComponent,
    VoltageWithSpeedComponent,
    VoltageSpeedKpisComponent,
    VoltageSpeedTimelineComponent,
    VoltageSpeedEngineStateComponent,
    VoltageSpeedScatterComponent,
    VoltageSpeedProfileComponent,
    VoltageSpeedChargingStabilityComponent,
    VoltageSpeedDataQualityComponent,
    VoltageSpeedCorrelationComponent,
    VoltageSpeedSummaryKpiComponent,
    VoltageSpeedAnomaliesComponent,
    VoltageSpeedHistoricalBaselineComponent,
    VoltageSpeedDailyInsightsComponent,
    VoltageSpeedDailyEventsComponent,
    VehicleFingerprintComponent,
    VehicleFingerprintIdentityComponent,
    VehicleFingerprintQualityComponent,
    VehicleFingerprintKpiPanelComponent,
    VehicleFingerprintElectricalSignatureComponent,
    VehicleFingerprintSpeedProfileComponent,
    VehicleFingerprintSpeedTrendComponent,
    VehicleFingerprintDailyDistanceComponent,
    VehicleFingerprintDailyPatternComponent,
    VehicleFingerprintDailyActivityComponent,
    VehicleFingerprintDataCoverageComponent,
    VehicleFingerprintBehavioralFeaturesComponent,
    VehicleFingerprintGeographicSignatureComponent,
    VehicleFingerprintElectricalSummaryComponent,
    VehicleFingerprintAdvancedElectricalComponent,
    VehicleFingerprintElectricalTrendsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CarouselModule,
    FormsModule,
    HttpClientModule,
    ZXingScannerModule,
    NgxPrintModule,
    NgxSliderModule,
    NgxPersianModule,
    NgxEditorModule,
    NgxStarRatingModule,
    NgSelectModule,
    AngularSignaturePadModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    NgPersianDatepickerModule,
    ReactiveFormsModule,
    BrowserAnimationsModule, // required animations module
    AutocompleteLibModule,
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }), ServiceWorkerModule.register('ngsw-worker.js', {
      // enabled: environment.production,
      enabled: false,
    }),


  ],
  providers: [NotificationService, OtherService, MapService, GurdServiceService, DataService],
  bootstrap: [AppComponent]
})
export class AppModule { }
